import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { SkeletonLoader } from '../../../components/loading/SkeletonLoader';

// Explicit request: the header's two Journey widgets rendered their "empty" state first (no follow-ups,
// "Not scheduled") and then swapped to the real one once the activity history arrived. This holds the same
// space (same border / radius / height rules as the widgets' own roots) until that data is there.
const useStyles = makeStyles(() =>
    createStyles({
        card: {
            flex: '0 1 330px',
            boxSizing: 'border-box',
            height: '100%',
            padding: '12px 16px',
            borderRadius: 10,
            border: '1px solid rgba(0,0,0,0.08)',
            backgroundColor: 'rgba(0,0,0,0.015)',
        },
        // same flex rules as EnquiryJourneyTimelineWidget's own root
        timelineCard: {
            display: 'flex',
            alignItems: 'center',
            flex: '1 1 660px',
            alignSelf: 'stretch',
            minWidth: 660,
            maxWidth: 880,
            boxSizing: 'border-box',
            padding: '8px 12px',
            borderRadius: 10,
            border: '1px solid rgba(0,0,0,0.08)',
            backgroundColor: 'rgba(0,0,0,0.015)',
            '@media (max-width: 640px)': { minWidth: 0 },
        },
        timelineRow: { display: 'flex', alignItems: 'flex-start', width: '100%' },
        timelineStep: { flex: '1 1 0', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 },
        timelineConnector: { flex: '1 1 0', minWidth: 24, height: 32, display: 'flex', alignItems: 'center', padding: '0 6px' },
    }),
);

interface HeaderWidgetSkeletonProps {
    variant: 'nextFollowUp' | 'journey';
}

export const HeaderWidgetSkeleton: React.FC<HeaderWidgetSkeletonProps> = ({ variant }) => {
    const classes = useStyles();

    if (variant === 'nextFollowUp') {
        return (
            <div className={classes.card}>
                <SkeletonLoader variant="shape" shape="text" width="45%" height={14} />
                <SkeletonLoader variant="shape" shape="text" width="80%" height={26} />
                <SkeletonLoader variant="shape" shape="text" width="60%" height={14} />
            </div>
        );
    }

    return (
        <div className={classes.timelineCard}>
            <div className={classes.timelineRow}>
                {[0, 1, 2, 3].map((index) => (
                    <React.Fragment key={index}>
                        <div className={classes.timelineStep}>
                            <SkeletonLoader variant="shape" shape="circle" width={32} height={32} />
                            <SkeletonLoader variant="shape" shape="text" width="60%" height={14} />
                            <SkeletonLoader variant="shape" shape="text" width="40%" height={12} />
                        </div>
                        {index < 3 && (
                            <div className={classes.timelineConnector}>
                                <SkeletonLoader variant="shape" shape="text" width="100%" height={2} />
                            </div>
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};
